import axios from 'axios';
import env from '../../config';

export const clientPanelInvitation = async ({ userEmail }: { userEmail: string }): Promise<string> => {
	const response = await axios.post(env.endpoints.clientPanelInvitation, {
		userEmail,
	}, {
		headers: {
			'Content-Type': 'application/json',
		},
	});

	return response.data.passwordResetLink;
};
